import { MainPadding } from "../../../../styles/Main.styles";
import TableFC, {
  TableFCBodyProps,
  TableHeadProps,
} from "../../../../components/table/Table";
import TableHeader from "../../../../components/table/TableHeader";
import { useNavigate } from "react-router";
import React, { useState } from "react";
import { useGetPurchaseInvoices } from "../../api/invoice/purchase/resolver";
import { useGetInvoiceConstant } from "../../api/invoice/constant/resolver";
import { M_InvoicePurchase } from "../../type/Invoice.type";
import { useGenerateArrayFromObj } from "../../../../components/input/hook/useGenerateOptions2";

export default function MainPembelian() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { data: dataRawInvoiceConstant } = useGetInvoiceConstant();
  const dataInvoiceConstant = dataRawInvoiceConstant?.data.data;
  const { data: dataRawInvoices, isLoading: loadingFetch } =
    useGetPurchaseInvoices({ keyword, page });
  const { data: dataStatusInvoice } = useGenerateArrayFromObj({
    dataSource: dataInvoiceConstant?.status,
  });
  const dataInvoices = dataRawInvoices?.data.data.data;
  const header: TableHeadProps[] = [
    { title: "No" },
    { title: "Nomor" },
    { title: "Status" },
    { title: "Total" },
    { title: "Tanggal" },
  ];
  const body: TableFCBodyProps[] = [
    { key: "purchase_invoice_number" },
    {
      key: "",
      component: (item: M_InvoicePurchase) => {
        const temp = dataStatusInvoice.find((t) => t.value === item.status);
        return <React.Fragment>{temp?.text}</React.Fragment>;
      },
    },
    { key: "grand_total", isMoney: true },
    { key: "purchase_invoice_date", isDate: true },
  ];

  return (
    <MainPadding>
      <TableHeader
        addButton
        filterLabel="Search Invoice Pembelian"
        searchBar
        onSearch={(e) => setKeyword(e)}
        onClickAdd={() => navigate("/invoice/pembelian/creation")}
      />
      <TableFC
        loading={loadingFetch}
        data={dataInvoices}
        body={body}
        showIndex
        totalRows={dataRawInvoices?.data.data.total}
        perColumns={perPage}
        onPerPageChange={(e) => setPerPage(e)}
        head={header}
        onPageChange={(e) => setPage(e)}
        onCellClick={(e) => navigate(`/invoice/pembelian/creation/${e.id}`)}
      />
    </MainPadding>
  );
}
